import styled from 'styled-components';
import { getDashboardComponentTop, getDashboardComponentLeft, getDashboardComponentHeight, getDashboardComponentWidth, } from '../Dashboard.utils';
import { Placeholder } from '../../Placeholder/Placeholder';
import { BreakPoints } from '../../../Resources/BreakPoints';
export const DashboardRoot = styled.div `
    @media (min-width: ${BreakPoints.minSmall}) {
        position: relative;
        height: ${(props) => props.height}px;
    }
`;
export const DashboardComponent = styled.div `
    margin-bottom: 24px;
    transition: top 0.1s ease-in-out, left 0.1s ease-in-out,
        width 0.1s ease-in-out;

    @media (min-width: ${BreakPoints.minSmall}) {
        margin-bottom: 0;
        position: absolute;
        top: ${(props) => getDashboardComponentTop(props.top, props.rowHeight, props.gutter)}px;
        height: ${(props) => getDashboardComponentHeight(props.height, props.rowHeight, props.gutter)}px;
        left: ${(props) => getDashboardComponentLeft(props.left, props.columnCount, props.gutter)};
        width: ${(props) => {
    if (props.columnCount === 1)
        return '100%';
    return getDashboardComponentWidth(props.width, props.columnCount, props.gutter);
}};
    }
`;
export const DashboardComponentPlaceholder = styled(Placeholder) `
    width: 100%;
    height: 100%;
    box-shadow: 0px 0.3px 0.9px rgba(0, 0, 0, 0.108),
        0px 1.6px 3.6px rgba(0, 0, 0, 0.132);
`;
//# sourceMappingURL=Dashboard.styled.js.map